module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product20-173f03f2d5428bf4105605079e45528c.jpg";